import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import { useNavigate, useParams } from "react-router-dom";
import SvgImage from "../Icons/Icons";
import DetailsCard from "./Components/DetailsCard";
import ExpenseCard from "./Components/ExpenseCards";
import {
  tripReport,
  getLRList,
  getTripLedger,
  getEachRoute,
  getTripExpenseAction,
  deleteTriporLr,
} from "../../services/Store/Actions/TripsAction";
import { sendAnalitics, toastStatus } from "../../services/Store/Actions/appActions";
import ManageDriverAddBalance from "../Modals/ManageDriverAddBalance";
import RechargeFastagButttonModal from "../Modals/rechargeFastagButton";
import OMCLoadModal from "../ManageDriver/SubComponents/NewDriverSideSection/SubComponents/Banners/OMCLoadModal";
import Toast from "../subComponents/toast";
import moment from "moment";
import { getFastagWalletBalance } from "../../services/Store/Actions/fastagAction";
import { msToTime } from "../../services/Utils/functions";
import { clearCustomerRecievables } from "../../services/Store/Actions/receivableActions";
import FastagVehicleTransactionTrip from "./Components/TransactionHistory/FastagVehicleTransactionTrip";
import CardTransactionTrip from "./Components/TransactionHistory/CardTransactionTrip";
import FuelTransactionTrip from "./Components/TransactionHistory/FuelTransactionTrip";
import CashTransactionTrip from "./Components/TransactionHistory/CashTransactionTrip";
import EditTripV2 from "../TripsMainV2/Components/EditTripV2";
import { getCustomerAction } from "../../services/Store/Actions/customerAction";
import EndTripModal from "./Components/EndTrip/index";
import ViewLr from "../TripsMainV2/Components/ViewLr";
import AddLr from "../TripsMainV2/Components/AddLr";
import TripLedger from "./Components/TransactionHistory/TripLedger";
import PaymentDetails from "../ManageCustomersDetailsV2/SubComponents/PaymentDetails";
import SattlePaymentDetails from "../ManageCustomersDetailsV2/SubComponents/SattlePaymentDetails";
import { getWalletBalAction } from "../../services/Store/Actions/LogipeCardActions";
import {
  getVendorAction,
  getVendorDetailsAction,
} from "../../services/Store/Actions/beneficiaryAction";
import DriverDashboardAddExpense from "../Modals/DriverDashboardAddExpense";
import CollectPayment from "./Components/CollectPayment";
import { omcVehicleBalanceAction } from "../../services/Store/Actions/omcActions";
import PayVendor from "./Components/PayVendor";
import { ClipLoader } from "react-spinners";
import ConfirmationModal from "../subComponents/confirmModal";
function TripDetailsV2(props) {
  let { sideBar } = props;

  const [itemTemp, setItemTemp] = useState({});
  const [routeData, setRouteData] = useState({});
  const [fuelVendor, setFuelVendor] = useState({});
  const [fleetVendor, setFleetVendor] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [paymentDetailsModal, setPaymentDetailsModal] = useState(false);
  const [sattlePaymentDetailsModal, setSattlePaymentDetailsModal] =
    useState(false);
  const [isTrips, setIsTrips] = useState(0);
  const [deleteTrip, setDeleteTrip] =
  useState(false);
  const [isGPS, setIsGPS] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [open5, setOpen5] = useState(false);
  const [tripLoader, setTripLoader] = useState(false);
  const navigate = useNavigate();

  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [payVendor, setPayVendor] = useState(false);
  const [open, setOpen] = useState(false);
  const [all, setAll] = useState(false);
  const [cash, setCash] = useState(false);
  const [fuel, setFuel] = useState(false);
  const [card, setCard] = useState(false);
  const [tripLedger, setTripLedger] = useState(true);
  const [fastag, setFastag] = useState(false);
  const [openFuel, setOpenFuel] = useState(false);
  const [openChooseMethod, setOpenChooseModal] = useState(false);
  const [openOMCPhone, setOpenOMCPhone] = useState(false);
  const [freight, setFreight] = useState(false);
  const [onHoverStop, setHoverStop] = useState(-3);
  const [onHoverStopR, setHoverStopR] = useState(-3);

  const [viewFreight, setViewFreight] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [openEndTripModal, setOpenEndTripModal] = useState(false);

  let { id } = useParams();
  const dispatch = useDispatch();

  let { tripExpense } = useSelector((store) => store?.trip);

  const freightDetails = useSelector((state) => state?.trip?.freightList);
  const omc_balace = useSelector((state) => state?.omc?.omc_balace);
  const { authUser } = useSelector((state) => state?.loginReducer);
  const { managerControlList } = useSelector((state) => state?.userManagement);
  const toastObject = useSelector((state) => state?.app?.toastObject);
  const balanceRecord = useSelector(
    (state) => state?.LogipeCard?.balanceRecord
  );
  const { vendorDetails } = useSelector((state) => state?.beneficiary);
  const { fastagWallet } = useSelector((state) => state?.fastag);
  let totalExpense;
  totalExpense =
    parseInt(tripExpense?.totalCashExpense || 0) +
    parseInt(tripExpense?.totalDriverExpense || 0) +
    parseInt(tripExpense?.totalFastagExpense || 0) +
    parseInt(tripExpense?.totalFuelExpense || 0) +
    parseInt(tripExpense?.totalVendorExpense || 0);

  let totalExpenseExpacted = 0;
  totalExpenseExpacted +=
    parseInt(tripExpense?.driverTotal || 0) +
    parseInt(tripExpense?.fastagTotal || 0) +
    parseInt(tripExpense?.fuelTotal || 0) +
    parseInt(tripExpense?.cashTotal || 0) +
    parseInt(tripExpense?.vendorTotal || 0);

  const accountStatus = balanceRecord?.accountStatus;
  const [podStatus,setPodStatus] = useState(-1);
  function countPodAndLr(stops, freightDetails) {
    let podEnd = {};
    let deliveryCounts = [];
    let s = new Set();
    for (let key in stops) {
      s.add(key);
    }
  
  let locationToStop = {};
  for (let key in stops) {
      // if(key == "0") continue;  //STARTING POINT
      let location = stops[key];
      if (!locationToStop[location]) {
          locationToStop[location] = [];
      }
      locationToStop[location].push(key);
  }
  
  
  console.log("sfsedfs",stops,freightDetails)
  let poddd = 0;
  for(const e of s){
    if(e == "0") continue;
    let location = stops[e];
    let froms = freightDetails?.filter((e) => e?.toAddress?.cityName == location);
    let toArr = locationToStop[location];
    console.log("sfsdfersedfs",froms,location,e)
  
    for (let index = 0; index < froms.length; index++) {
      const el = froms[index];
      let ex = deliveryCounts?.find((e) => el?.freightId == e)
      if(ex) continue;
      let finalKey = -1;
      let fromAddress = el?.fromAddress?.cityName;
      let des = locationToStop[fromAddress];
      console.log("des=======",e,"for",des)
  
      des?.map((ele) => {
        if(ele < e) finalKey = e;
      })
      if(finalKey != -1){
        console.log("=======finalKey",e,"for",finalKey,el)
        deliveryCounts.push(el?.freightId)
        let pods = 0;
        if(el?.podUrlData?.length > 0 || el?.reportingDate || el?.deliveryDate){
          pods = 1
        }
        podEnd[finalKey] = {
          lr : (podEnd[finalKey]?.lr || 0) + 1,
          pod : (podEnd[finalKey]?.pod || 0) + pods,
        }
        console.log("=======finalKey",podEnd[finalKey],pods)
        if(pods == 1){
          poddd = e;
        }
      }
    }

  }
  // console.log("knsdknfekn",podEnd[finalKey])
  if(poddd != 0){
    podEnd[poddd]["mark"] = 1;
  }
  else podEnd["0"] = {
    lr : 0,
    pod : 0,
    mark : 1,
  }
  console.log("nshiohfier",podEnd)
    return podEnd;
  }
  const fastagWalletAmount =
    fastagWallet.balance == null ? 0 : fastagWallet.balance;
  let Earnings = 0;
  let stops = {};

  for (let index = 0; index < itemTemp?.stopList?.length; index++) {
    stops[index] =
      itemTemp?.stopList?.[index]?.cityName;
  }
  let stopsArr = Object.values(stops);
  let stopsStr = "";
  let mid = itemTemp?.stopList?.findIndex((e) => e?.mid == true);
  console.log("erferrefwe",itemTemp?.stopList,freightDetails,mid)
  for (let index = 0; index < stopsArr?.length; index++) {
    if (index > 0) {
      stopsStr += ", ";
    }
    stopsStr = stopsStr + stopsArr?.[index];
  }
  let Shortage = 0;
  let podEnd = countPodAndLr(stops,freightDetails);
  let Penalties = 0;
  

  console.log("jwenjfnejnf",itemTemp?.stopList,freightDetails,podEnd)


  for (let index = 0; index < freightDetails?.length; index++) {
    Earnings = Earnings + freightDetails?.[index]?.freightAmount;
    Shortage = Shortage + (freightDetails?.[index]?.shortage || 0);
    Penalties = Penalties + freightDetails?.[index]?.charges;
    // let podCount,lrCount;
    // console.log("ksnifhire",toAdd,index,stops)
    // for (let i = 0; i < toAdd.length; i++) {
    //   const element = toAdd[i];
    //   let key = Object.keys(element);
    //   if(key != "0") {
    //     podCount = podEnd?.[element[key]]?.pod || 0;
    //     lrCount = podEnd?.[element[key]]?.lr || 0;
    //   }
    // }
    // if (freightDetails?.[index]?.podUrlData?.length > 0) {
    //   podCount += 1;
    // }
    // podEnd[freightDetails?.[index]?.toAddress?.cityName] = {
    //   pod: podCount,
    //   lr: lrCount + 1,
    // };
  }

  const toggleEndTripModal = () => {
    if (["2", "3", 2, 3].includes(isTrips))
      setOpenEndTripModal(!openEndTripModal);
  };

  const paymentDetailsModalToggle = () =>
    setPaymentDetailsModal(!paymentDetailsModal);
  const sattlePaymentDetailsModalToggle = () =>
    setSattlePaymentDetailsModal(!sattlePaymentDetailsModal);

  const toggleModal6 = () => {
    setOpen6(!open6);
  };
  const collectPayment = () => {
    setOpen6(true);
  };
  const handleClose4 = () => {
    setOpen4(false);
  };
  const toggleModal4 = () => {
    setOpen4(!open4);
  };
  const toggleModal5 = () => {
    setOpen5(!open5);
  };
  const handleClose5 = () => {
    setOpen5(false);
  };
  const toggleModal3 = () => {
    setOpen3(!open3);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };
  const rechargeCard = () => {
    setOpen3(true);
  };
  const addExpense = () => {
    setOpen(true);
  };
  const handleClose2 = () => {
    setOpen(false);
  };
  const toggleModal2 = () => {
    setOpen(!open);
  };
  const loadOmc = () => {
    setOpenFuel(true);
  };
  const handleCloseFuel = () => {
    setOpenFuel(false);
  };
  const toggleModalFuel = () => {
    setOpenFuel(!openFuel);
  };
  const loadVendor = () => {
    setPayVendor(true);
  };
  const toggleModalVendor = () => {
    setPayVendor(!payVendor);
  };

  const addFreight = () => {
    if (["2", "3", 2, 3].includes(isTrips)) setFreight(!freight);
  };
  const viewFreightfunc = () => {
    if (["1", "2", "3", 1, 2, 3].includes(isTrips))
      setViewFreight(!viewFreight);
  };
  const filterList = (k) => {
    if (k === "all") {
      setAll(true);
      setCard(false);
      setCash(false);
      setFastag(false);
      setFuel(false);
      setTripLedger(false);
    } else if (k === "card") {
      setCard(true);
      setAll(false);
      setCash(false);
      setFastag(false);
      setFuel(false);
      setTripLedger(false);
      // cardTransactionsData();
    } else if (k === "cash") {
      setCash(true);
      setAll(false);
      setCard(false);
      setFastag(false);
      setFuel(false);
      setTripLedger(false);
      // cashTransactionFunc()
    } else if (k === "fastag") {
      setFastag(true);
      setAll(false);
      setCard(false);
      setCash(false);
      setFuel(false);
      setTripLedger(false);
      // fastagVehicleTransactionFunc()
    } else if (k === "fuel") {
      setFuel(true);
      setAll(false);
      setCard(false);
      setCash(false);
      setFastag(false);
      setTripLedger(false);
      // omcTransactionData();
    } else if (k === "ledger") {
      setFuel(false);
      setAll(false);
      setCard(false);
      setCash(false);
      setFastag(false);
      setTripLedger(true);
      // omcTransactionData();
    }
  };

  useEffect(() => {
    setIsTrips(
      authUser?.company?.isTrips && authUser?.user?.type == 2
        ? 3
        : authUser?.company?.isTrips && managerControlList?.tripAccess
        ? managerControlList?.tripAccess
        : 0
    );
    setIsGPS(authUser?.company?.customFeatures?.includes(7)  ? 1 : 0);
  }, [authUser, managerControlList]);

  useEffect(() => {
    if (JSON.stringify(itemTemp) == "{}") {
      let tempo = sessionStorage.getItem("row");
      setItemTemp(JSON.parse(tempo));
      if (JSON.parse(tempo)?.routeId) {
        dispatch(getEachRoute({ routeId: JSON.parse(tempo)?.routeId }));
      }
      if (tempo?.fleetId) {
        dispatch(omcVehicleBalanceAction(tempo?.fleetId));
      }
      if (tempo?.vendorId)
        dispatch(getVendorDetailsAction({ id: tempo?.vendorId }, (resp) => {}));
      dispatch(sendAnalitics("Page_visit_TripDetails"));
    } else {
      // dispatch(getWalletBalAction(itemTemp?.userId));
      // dispatch(getVehicleDetails(itemTemp?.fleetId));
      if (itemTemp?.routeId) {
        dispatch(getEachRoute({ routeId: itemTemp?.routeId }));
      }
      if (itemTemp?.vendorId)
        dispatch(
          getVendorDetailsAction({ id: itemTemp?.vendorId }, (resp) => {})
        );
      if(itemTemp?.fleetId){
        dispatch(omcVehicleBalanceAction(itemTemp?.fleetId));
      }
      dispatch(sendAnalitics("Page_visit_TripDetails"));
    }
  }, [itemTemp?.tripId, id, refresh]);

  useEffect(() => {
    // dispatch(clearCustomerRecievables());
    // if (
    //   itemTemp?.freightData?.[0]?.customerId !== undefined &&
    //   itemTemp?.freightData?.[0]?.customerId !== ""
    // ) {
    //   dispatch(
    //     getCustomerAction({
    //       customerId: itemTemp?.freightData?.[0]?.customerId,
    //     })
    //   );
    // }
  }, [itemTemp?.freightData?.[0]?.customerId, itemTemp?.tripId]);
  console.log("useEffect again2 sdsdsd", itemTemp?.tripId, id, refresh);
  useEffect(() => {
    if (id !== undefined && id !== "" && !itemTemp?.tripId) {
      console.log(
        "useEffect again2 sdsdsd -------- ",
        itemTemp?.tripId,
        id,
        refresh
      );
      dispatch(
        getLRList({ tripId: id }, (res) => {
          console.log("rerere", res);
        })
      );
      dispatch(
        getTripExpenseAction({ tripId: id }, (res) => {
          if (res?.status == 200) {
            console.log("", res?.data?.data?.trip);
            if (res?.data?.data?.trip) {
              setItemTemp(res?.data?.data?.trip);
            }
          }
        })
      );
    }
    if (itemTemp?.userId) dispatch(getWalletBalAction(itemTemp?.userId));
  }, [itemTemp?.tripId, id, refresh]);

  useEffect(() => {
    if (open4) {
      dispatch(getFastagWalletBalance());
    }
  }, [open4]);

  useEffect(() => {
    if (freight) {
    } else {
      if (itemTemp?.tripId) {
        dispatch(
          getLRList(
            {
              offset: 0,
              limit: 10,
              tripId: itemTemp?.tripId,
            },
            (res) => {
              console.log("getLRListgetLRList", res);
            }
          )
        );
      }
    }
  }, [freight]);
  useEffect(() => {
    if (tripExpense?.fuelVendorId) {
      dispatch(
        getVendorAction(
          {
            limit: 1,
            offset: 0,
            isLogipeVendor: 0,
            vendorId: tripExpense?.fuelVendorId,
          },
          (res) => {
            if (res?.status == 200) {
              console.log("getVendorAction", res?.data?.data);
              setFuelVendor(res?.data?.data?.vendorList?.rows?.[0]);
            }
          }
        )
      );
    }
  }, [tripExpense]);
  useEffect(() => {
    console.log("asdaeewerdsfadfaz", itemTemp);
    if (itemTemp?.fleet?.vendorId) {
      dispatch(
        getVendorAction(
          {
            limit: 1,
            offset: 0,
            isLogipeVendor: 0,
            vendorId: itemTemp?.fleet?.vendorId,
          },
          (res) => {
            if (res?.status == 200) {
              console.log("getVendorAction", res?.data?.data);
              setFleetVendor(res?.data?.data?.vendorList?.rows?.[0]);
            }
          }
        )
      );
    }
  }, [itemTemp?.tripId]);

  return (
    <div
      className="container topMargin sideBarMargin"
      style={{
        marginLeft: sideBar ? "220px" : "100px",
        maxWidth: sideBar ? windowWidth - 240 : windowWidth - 130,
      }}
    >
      <div className="main1" style={{ backgroundColor: "white" }}>
        <div className="col-lg-12 con1 d-flex">
          <div className="vrnRow d-flex">
            <div>
              <div className="headingLow semiBold">
                {" "}
                {itemTemp?.Fleet?.regNumber}
              </div>
              <div className="heading2 Bold" style={{ marginTop: "8px" }}>
                Trip No. - {itemTemp?.tripNo}
              </div>
            </div>

            <button
              className="btn-edit-details"
              style={{ marginLeft: "20px" }}
              onClick={() => {
                if (["2", "3", 2, 3].includes(isTrips)) setOpen5(true);
              }}
            >
              Edit Details
            </button>
            {itemTemp?.isActive == 2 ? (
              <button
                className="btn-edit-details"
                style={{ marginLeft: "10px" }}
                onClick={toggleEndTripModal}
              >
                <text style={{ color: "white" }}>End Trip</text>
              </button>
            ) : null}
            <button
              className="btn-edit-details"
              style={{ marginLeft: "10px" }}
              onClick={viewFreightfunc}
            >
              View Freights
            </button>
            <button
              className="btn-edit-details"
              style={{ marginLeft: "10px" }}
              onClick={addFreight}
            >
              Add Freight
            </button>
            {itemTemp?.isActive != 1 ? (
              <button
                className="btn-edit-details"
                style={{ marginLeft: "10px", width: "150px" }}
                onClick={() => {
                  if (["1", "2", "3", 1, 2, 3].includes(isTrips))
                  setSattlePaymentDetailsModal(true);

                }}
              >
                Settle Payments
              </button>
            ) : null}
              <button
                className="btn-edit-details"
                style={{ marginLeft: "10px", width: "150px"}}
                onClick={() => {
                  if (["1", "2", "3", 1, 2, 3].includes(isTrips))
                    setDeleteTrip(!deleteTrip)
                }}
              >
                Delete Trip
              </button>
          </div>
          <div className="vrnRowRight d-flex">
            <button
              className="btn-edit-details"
              style={{
                marginLeft: "10px",
                borderRadius: "15px",
                background: "#09BD7B",
              }}
            >
              {itemTemp?.isActive == 2
                ? "Running"
                : itemTemp?.isActive == 1
                ? "Not Started"
                : "Completed"}
            </button>
          </div>
        </div>
        <div style={{ marginTop: "25px", marginBottom: "50px" }}>
          <div
            style={{
              height: 10,
              backgroundColor: "#485B7C",
              borderRadius: 10,
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {stopsArr?.map((item, index) => {
              return (
                <>
                {
                  mid && mid != -1 && mid < index ?  <></> :
                  <div
                  style={{ textAlignList: "center", cursor: "pointer" }}
                  onMouseEnter={() => {
                    setHoverStop(index);
                  }}
                  onMouseLeave={() => {
                    setHoverStop(-3);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        index == 0
                          ? "start"
                          : index == stopsArr?.length - 1
                          ? "end"
                          : "center",
                    }}
                  >
                    {podEnd[index]?.mark == 1 ? 
                  <div
                  style={{
                    height: 20,
                    // backgroundColor: "#ED752E",
                    width: 6,
                    borderRadius: 3,
                    marginTop: -11,
                  }}
                >
                  <img src = {require("../../assets/images/truck-32.png")} />
                  </div> :                     <div
                      style={{
                        height: 20,
                        backgroundColor: "#ED752E",
                        width: 6,
                        borderRadius: 3,
                        marginTop: -5,
                      }}
                    >
                      </div>
                    }

                  </div>
                  <div
                    style={{
                      color: "#485B7C",
                      marginTop: 5,
                    }}
                  >
                    {item ? item : "-"}
                  </div>
                  {onHoverStop == index ? (
                    index!=0 ? 
                    <div className="expenseCard3" style={{}}>
                      <div>Pod Uploaded : {podEnd[index]?.pod || 0}</div>
                      <div>LRs : {podEnd[index]?.lr || 0}</div>
                    </div> : <></>
                  ) : null}
                </div>
                  
                }
                </>
              );
            })}
          </div>
        </div>
        {
          mid && mid != -1 ?        
           <div style={{ marginTop: "25px", marginBottom: "50px" }}>
          <div
            style={{
              height: 10,
              backgroundColor: "#485B7C",
              borderRadius: 10,
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {stopsArr?.reverse()?.map((item, index) => {
              return (
                <>
                {
                  mid && stopsArr?.length-1-mid < index ?  <></> :
                  <div
                  style={{ textAlignList: "center", cursor: "pointer" }}
                  onMouseEnter={() => {
                    setHoverStopR(index);
                  }}
                  onMouseLeave={() => {
                    setHoverStopR(-3);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent:
                        index == 0
                          ? "start"
                          : index == stopsArr?.length - 1
                          ? "end"
                          : "center",
                    }}
                  >
                    {stopsArr?.length-1-index!=mid && podEnd[stopsArr?.length-1-index]?.mark == 1 ? 
                  <div
                  style={{
                    height: 20,
                    // backgroundColor: "#ED752E",
                    width: 6,
                    borderRadius: 3,
                    marginTop: -11,
                  }}
                >
                  <img src = {require("../../assets/images/truck-32.png")} style={{transform: "scale(1, -1) rotate(180deg)"}} />
                  </div> :                     <div
                      style={{
                        height: 20,
                        backgroundColor: "#ED752E",
                        width: 6,
                        borderRadius: 3,
                        marginTop: -5,
                      }}
                    >
                      </div>
                    }

                  </div>
                  <div
                    style={{
                      color: "#485B7C",
                      marginTop: 5,
                    }}
                  >
                    {item && stopsArr?.length-1-index != mid ? item : "-"}
                  </div>
                  {onHoverStopR == index ? (
                    index!=(mid) ? 
                    <div className="expenseCard3" style={{}}>
                      {/* {console.log("ejrijri",stopsArr?.length-1-index,mid,mid-index,index,stopsArr)} */}
                      <div>Pod Uploaded : {podEnd[stopsArr?.length-1-index]?.pod || 0}</div>
                      <div>LRs : {podEnd[stopsArr?.length-1-index]?.lr || 0}</div>
                    </div> : <></>
                  ) : null}
                </div>
                  
                }
                </>
              );
            })}
          </div>
        </div> : <></>
        }



        <div className="detailsCard ">
          <DetailsCard
            key1={"From"}
            key2={"To"}
            key3={itemTemp?.userId ? "Driver" : itemTemp?.vendorId ? "Vendor" : "Driver"}
            key4={"Vehicle"}
            key5={"Start Date"}
            key6={"End Date"}
            value1={
              itemTemp?.sourceAddress
                ? itemTemp?.sourceAddress?.address +
                  ", " +
                  itemTemp?.sourceAddress?.cityName +
                  ", " +
                  itemTemp?.sourceAddress?.stateName
                : itemTemp?.source
            }
            value2={
              itemTemp?.destAddress
                ? itemTemp?.destAddress?.address +
                  ", " +
                  itemTemp?.destAddress?.cityName +
                  ", " +
                  itemTemp?.destAddress?.stateName
                : itemTemp?.destination
            }
            value3={
              itemTemp?.userId
                ? itemTemp?.User?.fullName || "-"
                : vendorDetails ? vendorDetails?.name : "-"
            }
            value4={
              itemTemp?.Fleet?.regNumber != undefined
                ? itemTemp?.Fleet?.regNumber
                : "-"
            }
            value5={moment(
              itemTemp?.startTime || itemTemp?.expectedStartTime
            ).format("DD-MM-YYYY HH:mm")}
            value6={
              itemTemp?.endTime
                ? moment(itemTemp?.endTime).format("DD-MM-YYYY HH:mm")
                : itemTemp?.expectedEndTime == null
                ? "-"
                : moment(itemTemp?.expectedEndTime).format("DD-MM-YYYY HH:mm")
            }
            userId={itemTemp?.userId}
            fleetId={itemTemp?.fleetId}
            itemTemp={itemTemp}
            isGPS={isGPS}
          />
          <DetailsCard
            key1={"Freights"}
            key2={"Freight Amount"}
            key3={"Pending PODs"}
            key4={"Start Odometer"}
            key5={"End Odometer"}
            key6={"Earning/KM"}
            value1={freightDetails.length}
            value2={
              Earnings != undefined
                ? "₹ " + Earnings?.toLocaleString("en-IN") || "₹ 0"
                : "-"
            }
            value3={freightDetails.filter((x) => !x.podUrlData).length || 0}
            value4={itemTemp?.startKmReading || "NA"}
            value5={itemTemp?.endKmReading || "NA"}
            value6={
              itemTemp?.expectedDistanceKM
                ? "₹ " +
                    (
                      parseInt(Earnings || 0) /
                      parseInt(itemTemp?.expectedDistanceKM || 1)
                    )?.toLocaleString("en-IN") || "-"
                : "-"
            }
            itemTemp={itemTemp}
          />
          <DetailsCard
            key1={"Total Expense"}
            key2={itemTemp?.userId ? "Driver" : "Vendor"}
            key3={"Fuel"}
            key4={"Fastag"}
            key5={"Others"}
            key6={"Expense/KM"}
            value1={"₹ " + (totalExpense?.toLocaleString("en-IN") || "0")}
            value2={
              "₹ " +
              (itemTemp?.userId
                ? tripExpense?.totalDriverExpense?.toLocaleString("en-IN") ||
                  "0"
                : tripExpense?.totalVendorExpense?.toLocaleString("en-IN") ||
                  "0")
            }
            value3={
              "₹ " +
              (tripExpense?.totalFuelExpense?.toLocaleString("en-IN") || "0")
            }
            value4={
              "₹ " +
              (tripExpense?.totalFastagExpense?.toLocaleString("en-IN") || "0")
            }
            value5={
              "₹ " +
              (tripExpense?.totalCashExpense?.toLocaleString("en-IN") || "0")
            }
            value6={
              "₹ " + itemTemp?.expectedDistanceKM
                ? (
                    parseInt(totalExpense || 0) /
                    parseInt(itemTemp?.expectedDistanceKM || 1)
                  ).toFixed(2) || "-"
                : "-" || "0"
            }
          />
        </div>
        {itemTemp?.idleReason ? (
          <div
            style={{
              marginTop: "24px",
              fontSize: "14px",
              backgroundColor: "#FFFACD",
              color: "#FF8C00",
              borderWidth: "1px",
              borderColor: "#FF8C00",
              borderStyle: "solid",
              borderRadius: "12px",
              padding: "12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            Idle Reason : {itemTemp?.idleReason}
          </div>
        ) : null}

        {itemTemp?.delayedReason ? (
          <div
            style={{
              marginTop: "24px",
              fontSize: "14px",
              backgroundColor: "#FFFACD",
              color: "#FF8C00",
              borderWidth: "1px",
              borderColor: "#FF8C00",
              borderStyle: "solid",
              borderRadius: "12px",
              padding: "12px",
              fontWeight: 600,
              textAlign: "center",
            }}
          >
            Delayed Reason : {itemTemp?.delayedReason}
          </div>
        ) : null}

        <div className="expenseCards">
          <ExpenseCard
            svgName={"money"}
            name={"Net Earnings"}
            data={
              "₹ " +
              parseFloat(
                parseFloat(Earnings || 0) - parseFloat(totalExpense)
              )?.toLocaleString("en-IN")
            }
          />
          <ExpenseCard
            svgName={"distanceMoney"}
            name={"Net Earning/KM"}
            data={
              itemTemp?.expectedDistanceKM
                ? "₹ " +
                    (
                      parseFloat(
                        parseFloat(Earnings || 0) - parseFloat(totalExpense)
                      ) / parseInt(itemTemp?.expectedDistanceKM || 1)
                    )?.toLocaleString("en-IN") || "-"
                : "-"
            }
          />

          <ExpenseCard
            svgName={"distance"}
            name={"Total Distance"}
            data={
              parseFloat(itemTemp?.expectedDistanceKM || 0)?.toLocaleString(
                "en-IN"
              ) || "-"
            }
          />
          <ExpenseCard
            svgName={"distance"}
            name={"Stopes"}
            data={
              stopsArr?.[0]
                ? `${stopsArr?.[0]}, ${stopsArr?.[1]} ${
                    stopsArr?.length - 2 > 0
                      ? "and " + parseInt(stopsArr?.length - 2) + " more"
                      : ""
                  } `
                : "No Stop"
            }
            viewMore={true}
            viewMoreText={stopsArr?.[0] ? `${stopsStr}` : "No Stop"}
          />
          <ExpenseCard
            svgName={"time"}
            name={"Duration"}
            data={
              itemTemp?.expectedEndTime
                ? msToTime(
                    new Date(itemTemp?.expectedEndTime) -
                      new Date(itemTemp?.expectedStartTime)
                  ) + " Hrs."
                : msToTime(new Date() - new Date(itemTemp?.expectedStartTime)) +
                  " Hrs."
            }
          />
        </div>
        <div className="expenseCards" style={{ justifyContent: "flex-start" }}>
          <div onClick={addExpense}>
            <ExpenseCard
              name={`Add Cash Expense`}
              textColor={{
                color: "#E57231",
                textAlign: "center",
                width: "100px",
              }}
            />
          </div>
          {omc_balace ? (
            <div onClick={loadOmc}>
              <ExpenseCard
                name={"Recharge Fuel Wallet"}
                textColor={{
                  color: "#E57231",
                  textAlign: "center",
                  width: "150px",
                }}
              />
            </div>
          ) : (
            <></>
          )}
          {accountStatus == 4 && itemTemp?.userId ? (
            <div onClick={rechargeCard}>
              <ExpenseCard
                name={"Pay Driver"}
                textColor={{
                  color: "#E57231",
                  textAlign: "center",
                  justifyContent: "center",
                }}
              />
            </div>
          ) : (
            <></>
          )}

          <div onClick={collectPayment}>
            <ExpenseCard
              name={"Collect Payment"}
              textColor={{
                color: "#E57231",
                textAlign: "center",
                justifyContent: "center",
              }}
            />
          </div>
          {itemTemp?.vendorId ? (
            <div onClick={loadVendor}>
              <ExpenseCard
                name={"Pay Vendor"}
                textColor={{
                  color: "#E57231",
                  textAlign: "center",
                  width: "150px",
                }}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        {itemTemp?.isActive == 1 ? (
          <div
            style={{
              marginTop: "24px",
            }}
          >
            <div className="padding32 textCenter">
              <SvgImage name="TripsMap" />
              <div className="Bold heading1 padding24T padding16B FontSuperBold primaryBlack">
                Start Trip
              </div>
              <div
                style={{
                  marginBottom: "16px",
                }}
                className="greyFont heading3"
              >
                Start to manage expense easily
              </div>
              <button
                className={"Medium heading3 greenButton"}
                style={{ paddingLeft: "1rem", paddingRight: "1rem" }}
                onClick={() => {
                  setPaymentDetailsModal(true);
                }}
              >
                Start Trip Now
              </button>
            </div>
          </div>
        ) : (
          <div>
            <div className="transactions">
              <div className="heading2 Bold">Transactions</div>
              <div className="d-flex justify-content-between">
                <div className="txnCategory">
                  <button
                    onClick={() => filterList("ledger")}
                    className={
                      tripLedger
                        ? "btnCatSelected heading4 Medium"
                        : "btnCat heading4 Medium"
                    }
                  >
                    Ledger
                  </button>
                  <button
                    onClick={() => filterList("card")}
                    className={
                      card
                        ? "btnCatSelected heading4 Medium"
                        : "btnCat heading4 Medium"
                    }
                  >
                    Card
                  </button>
                  <button
                    onClick={() => filterList("fastag")}
                    className={
                      fastag
                        ? "btnCatSelected heading4 Medium"
                        : "btnCat heading4 Medium"
                    }
                  >
                    FasTag
                  </button>
                  <button
                    onClick={() => filterList("cash")}
                    className={
                      cash
                        ? "btnCatSelected heading4 Medium"
                        : "btnCat heading4 Medium"
                    }
                  >
                    Cash
                  </button>
                  <button
                    onClick={() => filterList("fuel")}
                    className={
                      fuel
                        ? "btnCatSelected heading4 Medium"
                        : "btnCat heading4 Medium"
                    }
                  >
                    Fuel
                  </button>
                </div>
                <div
                  className="heading3 semiBold"
                  style={{ marginLeft: "20px", cursor: "pointer" }}
                  onClick={() => {
                    console.log("clicked");
                    if(!tripLoader){
                      setTripLoader(true);
                      dispatch(
                        tripReport({ tripId: itemTemp?.tripId }, (res) => {
                          console.log("OSKSS", res);
                          setTripLoader(false);
                          if (res?.data?.type == "success") {
                            console.log("OPEININGDPF", res);
                            window.open(res?.data?.data?.url);
                          }
                        })
                      );
                    }
                  }}
                >

                  <SvgImage name="downloadImgGreen" />
                  {tripLoader ?                       
                  <ClipLoader
                        loading={true}
                        size={20}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      /> :                  
                       <span style={{ marginLeft: "10px" }}>Download Report</span>
                      }
                </div>
              </div>

              {fastag ? (
                <FastagVehicleTransactionTrip itemTemp={itemTemp} />
              ) : card ? (
                <CardTransactionTrip itemTemp={itemTemp} />
              ) : fuel ? (
                <FuelTransactionTrip itemTemp={itemTemp} />
              ) : cash ? (
                <CashTransactionTrip itemTemp={itemTemp} />
              ) : tripLedger ? (
                <TripLedger itemTemp={itemTemp} />
              ) : (
                ""
              )}
            </div>
          </div>
        )}
      </div>

      <DriverDashboardAddExpense
        open={open}
        toggleModal={toggleModal2}
        handleClose={handleClose2}
        name="Add Balance"
        driverBal={"SCDa"}
        cardType={1}
        driverName={props.driverName}
        accountStatus={props.accountStatus}
        modalName="Trip Number"
        itemTemp={itemTemp}
        value={itemTemp?.tripNo}
        transferType="2"
        expType={"trip"}
        tripId={itemTemp?.tripId}
      />
      {open5 ? (
        <EditTripV2
          toggle={toggleModal5}
          modal={open5}
          setModal={setOpen5}
          tripId={itemTemp?.tripId}
          tripData={itemTemp}
          tripExpense={tripExpense}
          setItemTemp={setItemTemp}
        />
      ) : null}

      {open3 ? (
        <ManageDriverAddBalance
          open={open3}
          toggleModal={toggleModal3}
          remarks={`Payment for Trip ${itemTemp?.tripNo}`}
          title="Logipe Account"
          handleClose={handleClose3}
          color={
            "LogipeAccount" === "Card Wallet" ? "title-color1" : "title-color2"
          }
          name="Add Balance"
          userId={itemTemp?.userId}
          cardType={itemTemp?.cardType}
          trip={true}
          driverName={itemTemp?.User?.fullName}
          itemTemp={itemTemp}
        />
      ) : null}

      <RechargeFastagButttonModal
        open={open4}
        handleClose={handleClose4}
        toggleModal={toggleModal4}
        remarks={`Recharge for Trip ${itemTemp?.tripNo}`}
        balance={fastagWalletAmount}
        no={itemTemp?.Fleet?.regNumber}
        fleetId={itemTemp?.fleetId}
        trip={true}
        itemTemp={itemTemp}
      />
      <OMCLoadModal
        userId={itemTemp?.userId}
        open={openFuel}
        toggleModal={toggleModalFuel}
        handleClose={handleCloseFuel}
        fleetId={itemTemp?.fleetId}
        trip={1}
      />
      {viewFreight ? (
        <ViewLr
          toggle={viewFreightfunc}
          freight={viewFreight}
          setFreight={setViewFreight}
          tripId={itemTemp?.tripId}
          location={"/trips/" + id}
        />
      ) : null}

      {freight ? (
        <AddLr
          toggle={addFreight}
          setFreight={setFreight}
          freight={freight}
          tripId={itemTemp?.tripId}
          location={"/trips/" + id}
          fleetId={itemTemp?.fleetId}
          onSkip={() => {}}
          tripData={itemTemp}
          setItemTemp={setItemTemp}
        />
      ) : null}

      {openEndTripModal ? (
        <EndTripModal
          toggle={toggleEndTripModal}
          modal={openEndTripModal}
          setModal={setOpenEndTripModal}
          location={"/trips/"}
          tripId={props?.item?.tripId}
          tripData={itemTemp}
          setItemTemp={setItemTemp}
          sattlePayment={sattlePaymentDetailsModalToggle}
          refreshList={() => {
            setRefresh(!refresh);
          }}
        />
      ) : null}
      {paymentDetailsModal ? (
        <PaymentDetails
          toggle={paymentDetailsModalToggle}
          setRouteData={setRouteData}
          tripData={itemTemp}
          modal={paymentDetailsModal}
          setModal={setPaymentDetailsModal}
          tripExpense={tripExpense}
          startTrip={true}
          setItemTemp={setItemTemp}
          vehicleMilage={itemTemp?.Fleet?.mileage || 0}
          driverSalary={itemTemp?.Fleet?.driverSalary || 0}
          // location={"/lr/"}
        />
      ) : null}
      {open6 ? (
        <CollectPayment
          toggle={toggleModal6}
          tripData={itemTemp}
          modal={open6}
          setModal={setOpen6}
          tripExpense={tripExpense}
          startTrip={true}
          setItemTemp={setItemTemp}
        />
      ) : null}
      {payVendor ? (
        <PayVendor
          toggle={toggleModalVendor}
          tripData={itemTemp}
          modal={payVendor}
          setModal={setPayVendor}
          tripExpense={tripExpense}
          startTrip={true}
          setItemTemp={setItemTemp}
        />
      ) : null}
      {sattlePaymentDetailsModal ? (
        <SattlePaymentDetails
          toggle={sattlePaymentDetailsModalToggle}
          tripData={itemTemp}
          modal={sattlePaymentDetailsModal}
          setModal={setSattlePaymentDetailsModal}
          tripExpense={tripExpense}
          setItemTemp={setItemTemp}
          fuelVandor={fuelVendor}
          fleetVendor={fleetVendor}
          vehicleMilage={itemTemp?.Fleet?.mileage || 0}
          driverSalary={itemTemp?.Fleet?.driverSalary || 0}
          company = {authUser?.company}
        />
      ) : null}

      {
        deleteTrip ?                    <ConfirmationModal
        isOpen={deleteTrip}
        onHide={() =>           setDeleteTrip(false)        
        }
        toggleModal={() => {
          setDeleteTrip(!deleteTrip)        
        }}
        handleClose={() => {
          setDeleteTrip(false)        
        }}
        onPress={() => {
          let toggleModalToast = () => {
            dispatch(
              toastStatus({
                toastStatus: false,
              })
            );
            navigate(`/trips`);
          };
          let handleCloseToast = () => {
            dispatch(
              toastStatus({
                toastStatus: false,
              })
            );
            navigate(`/trips`);
          };
          dispatch(
            deleteTriporLr(
              {
                id: itemTemp?.tripId,
                action  : 1
              },
              (response) => {
                console.log(
                  "kjnjsfnnvpkd",
                  response,
                  response?.type,
                  response?.type == "success",
                  response?.type === "success"
                );
                setDeleteTrip(false)        
                if (
                  response?.data && response?.data?.type === "success" 
                ) {
                  //window.location.reload();
                } else {
                  //alert(response);
                }
              },
              toggleModalToast,
              handleCloseToast
            )
          );
        }}
        msg={`Do You want to Delete ${itemTemp?.tripNo} Permanently`}
      /> : <></>
      }

      {toastObject.toastStatus ? (
        <Toast
          success={toastObject?.status}
          message={toastObject?.message}
          toggleModal={toastObject?.toggleModal}
          isOpen={toastObject?.toastStatus}
          name="trips"
          handleClose={toastObject?.handleClose}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
export default TripDetailsV2;
